import { useCallback } from 'react';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { COMPLETIONS_MUTATION_MAP, fillContent } from './utils/promptUtils';

const getMutation = (queryType) => COMPLETIONS_MUTATION_MAP[queryType] || COMPLETIONS_MUTATION_MAP.article;

function useCompletionsMutation({ queryType = 'smartAssist' }) {
  const { accountUuid } = useAuthentication();
  const [fetchCompletionsMutation, { data, loading, error }] = useMutation(getMutation(queryType), {
    noThrow: true,
  });

  useError(error);

  const fetchCompletions = useCallback(
    (promptData, fillData) => {
      const { uuid, systemContent, userContent, structuredOutput, maxCompletionTokens, temperature, model } =
        promptData?.findPrompt || {};
      fetchCompletionsMutation({
        variables: {
          model,
          temperature,
          maxCompletionTokens,
          metadata: {
            promptUuid: uuid,
            accountUuid,
          },
          messages: [
            {
              role: 'system',
              content: systemContent,
            },
            {
              role: 'user',
              content: fillContent(fillData, userContent),
            },
          ],
          responseFormat: {
            name: structuredOutput?.name || 'structured',
            schema: structuredOutput?.schema || {},
          },
        },
      });
    },
    [accountUuid, fetchCompletionsMutation],
  );

  return {
    fetchCompletions,
    data,
    loading,
    error,
  };
}

export { useCompletionsMutation };
